<h1 mat-dialog-title>
  {{ 'MEETING_SCHEDULER.BOOKING_LINK.UPDATE_PROMPT_TITLE' | translate }}
</h1>
<div mat-dialog-content>
  You are about to change this booking link from
  <span class="original-slug">/{{ data.originalSlug }}</span>
  to
  <span class="new-slug">/{{ data.newSlug }}</span>
  . Guests won't be able to book with you at
  <span class="original-slug">/{{ data.originalSlug }}</span>
  afterward, and you'll need to send the updated link to anyone with the old
  link.
</div>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onNoClick()">
    {{
      'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.DO_NOT_UPDATE'
        | translate
    }}
  </button>
  <button mat-raised-button color="primary" (click)="onYesClick()">
    {{
      'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CALENDAR_SLUG.DO_UPDATE'
        | translate
    }}
  </button>
</mat-dialog-actions>
